// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| EzClocker Table UX CSS Classes
| CSS variables defined in: /src/main/webapp/public/styles/common/ez-body.css
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
:root {
  /* Default Table Background */
  --ezTableBackgroundColor: var(--ezClockerWhite);
  /* Default Table Font */
  --ezTableFontColor: var(--ezFontColor);
  --ezTableFontSize: 12pt;
  --ezTableFontWeight: var(--ezFontWeight);
  --ezTableFontFamily: var(--ezTextFontFamily);
  /* Default Table Border */
  --ezTableBorderColor: var(--ezClockerGray);
  --ezTableBorderSize: 1px;
  --ezTableBorderStyle: solid;
  /* Header Cells */
  --ezTableHeaderCellBackgroundColor: var(--ezClockerNavy);
  --ezTableHeaderCellFontColor: var(--ezClockerWhite);
  --ezTableHeaderCellFontWeight: bold;
}

/* Table Styles */
table.ez-table {
  background-color: var(--ezTableBackgroundColor);
  color: var(--ezTableFontColor);
  font-size: var(--ezTableFontSize);
  font-weight: var(--ezTableFontWeight);
  font-family: var(--ezTableFontFamily);
  border-spacing: 0;
}

table.ez-table-transparent-full-width {
  width: 100%;
  padding: 2px;
  background-color: transparent;
  color: var(--ezTableFontColor);
  font-size: var(--ezTableFontSize);
  font-weight: var(--ezTableFontWeight);
  font-family: var(--ezTableFontFamily);
  border-spacing: 0;
}

table.ez-table-full-width {
  width: 100%;
  padding: 2px;
  background-color: var(--ezTableBackgroundColor);
  color: var(--ezTableFontColor);
  font-size: var(--ezTableFontSize);
  font-weight: var(--ezTableFontWeight);
  font-family: var(--ezTableFontFamily);
  border-spacing: 0;
}

table.ez-table-full-width-transparent {
  width: 100%;
  padding: 2px;
  background-color: transparent;
  color: var(--ezTableFontColor);
  font-size: var(--ezTableFontSize);
  font-weight: var(--ezTableFontWeight);
  font-family: var(--ezTableFontFamily);
  border-spacing: 0;
}

/* Table Body Styles */
tbody.ez-table-body {
  background-color: var(--ezTableBackgroundColor);
  padding: 2px;
  border-color: var(--ezTableBorderColor);
  border-style: solid;
  border-width: 1px;
}

tr.ez-table-row {
  padding: 0;
  border-style: none;
}

td.ez-table-cell {
  padding: 4px;
  background-color: var(--ezTableBackgroundColor);
  color: var(--ezTableFontColor);
  font-size: var(--ezTableFontSize);
  font-weight: var(--ezTableFontWeight);
  font-family: var(--ezTableFontFamily);
  border-color: var(--ezTableBorderColor);
  border-width: var(--ezTableBorderSize);
  border-style: var(--ezTableBorderStyle);
}

td.ez-table-cell-max-width-50 {
  padding: 4px;
  max-width: 50%;
  background-color: var(--ezTableBackgroundColor);
  color: var(--ezTableFontColor);
  font-size: var(--ezTableFontSize);
  font-weight: var(--ezTableFontWeight);
  font-family: var(--ezTableFontFamily);
  border-color: var(--ezTableBorderColor);
  border-width: var(--ezTableBorderSize);
  border-style: var(--ezTableBorderStyle);
}

td.ez-table-cell-min-width-50 {
  padding: 4px;
  min-width: 50%;
  background-color: var(--ezTableBackgroundColor);
  color: var(--ezTableFontColor);
  font-size: var(--ezTableFontSize);
  font-weight: var(--ezTableFontWeight);
  font-family: var(--ezTableFontFamily);
  border-color: var(--ezTableBorderColor);
  border-width: var(--ezTableBorderSize);
  border-style: var(--ezTableBorderStyle);
}

.ez-cell-align-top-left {
  vertical-align: top;
  text-align: left;
}

.ez-cell-align-middle-center {
  vertical-align: middle;
  text-align: center;
}

.ezTable-cell-align-top-center {
  vertical-align: top;
  text-align: center;
}

.ezTable-cell-align-bottom-center {
  vertical-align: bottom;
  text-align: center;
}

.ez-cell-align-middle-left {
  vertical-align: middle;
  text-align: left;
}

.ez-cell-vertical-align-top {
  vertical-align: top;
}

.ez-cell-vertical-align-bottom {
  vertical-align: bottom;
}

.ez-cell-vertical-align-middle {
  vertical-align: middle;
}

.ez-cell-horizontal-align-left {
  text-align: left;
}

.ez-cell-horizontal-align-center {
  text-align: center;
}

.ez-cell-horizontal-align-right {
  text-align: right;
}

td.ez-cell-width-33 {
  width: 33%;
}

/* Table Header Styles */
thead.ez-sticky-table-header {
  position: sticky;
}

thead.ez-table-header {
  padding: 4px;
  background-color: var(--ezTableHeaderCellBackgroundColor);
  color: var(--ezTableHeaderCellFontColor);
  font-size: var(--ezTableFontSize);
  font-weight: var(--ezTableHeaderCellFontWeight);
}

th.ezTables-cell-header-silver {
  padding: 4px;
  /* --ezClockerSilver defined in ez-body.css */
  background-color: var(--ezClockerSilver);
  /* --ezClockerBlack defined in ez-body.css */
  color: var(--ezClockerBlack);
  font-size: var(--ezTableFontSize);
  font-weight: var(--ezTableHeaderCellFontWeight);
  font-family: var(--ezTableFontFamily);
  /* --ezClockerGray defined in ez-body.css */
  border-color: var(--ezClockerGray);
  border-style: solid;
  border-width: 1px;
}

th.ez-table-cell-header {
  padding: 4px;
  background-color: var(--ezTableHeaderCellBackgroundColor);
  color: var(--ezTableHeaderCellFontColor);
  font-size: var(--ezTableFontSize);
  font-weight: var(--ezTableHeaderCellFontWeight);
  font-family: var(--ezTableFontFamily);
  border-color: var(--ezClockerGray);
  border-style: solid;
  border-width: 1px;
}

th.ez-table-cell-header-left-align {
  padding: 4px;
  background-color: var(--ezTableHeaderCellBackgroundColor);
  color: var(--ezTableHeaderCellFontColor);
  font-size: var(--ezTableFontSize);
  font-weight: var(--ezTableHeaderCellFontWeight);
  font-family: var(--ezTableFontFamily);
  text-align: left;
  vertical-align: top;
  border-color: var(--ezClockerGray);
  border-style: solid;
  border-width: 1px;
}

th.ez-table-cell-header-fixed {
  padding: 4px;
  position: sticky;
  top: 0;
  background-color: var(--ezTableHeaderCellBackgroundColor);
  color: var(--ezTableHeaderCellFontColor);
  font-size: var(--ezTableFontSize);
  font-weight: var(--ezTableHeaderCellFontWeight);
  font-family: var(--ezTableFontFamily);
  border-color: var(--ezClockerGray);
  border-width: 1px;
  border-style: solid;
}

td.ez-table-cell-width-50 {
  width: 50%;
}

td.ezTable-action-buttons-col {
  padding-top: 10px;
  padding-bottom: 10px;
  text-align: right;
  vertical-align: middle;
}

/* -------------------------------------------------------------------
| Large Tablet Screen Styles (https://yesviz.com/laptops.php)       |
------------------------------------------------------------------- */
/*
@media screen and (max-width: 1023px) {
}
*/
/* -------------------------------------------------------------------
| Small Tablet Screen Styles (https://yesviz.com/tablets.php)       |
------------------------------------------------------------------- */
/*
@media screen and (max-width: 768px) {
}
*/
/* -------------------------------------------------------------------
| Phone Screen Styles  (https://yesviz.com/mobiles.php)             |
------------------------------------------------------------------- */
/*
@media screen and (max-width: 480px) {
}
*/
/* -------------------------------------------------------------------
| Warable Screen Style  (https://yesviz.com/watches.php)            |
------------------------------------------------------------------- */
/*
@media screen and (max-width: 319px) {
}
*/`, "",{"version":3,"sources":["webpack://./public/styles/common/ez-tables.css"],"names":[],"mappings":"AAAA;;;iEAAA;AAKA;EACI,6BAAA;EACA,+CAAA;EAEA,uBAAA;EACA,sCAAA;EACA,uBAAA;EACA,wCAAA;EACA,4CAAA;EAEA,yBAAA;EACA,0CAAA;EACA,wBAAA;EACA,2BAAA;EAEA,iBAAA;EACA,wDAAA;EACA,mDAAA;EACA,mCAAA;AAHJ;;AAMA,iBAAA;AACA;EACI,+CAAA;EACA,8BAAA;EACA,iCAAA;EACA,qCAAA;EACA,qCAAA;EACA,iBAAA;AAHJ;;AAMA;EACI,WAAA;EACA,YAAA;EACA,6BAAA;EACA,8BAAA;EACA,iCAAA;EACA,qCAAA;EACA,qCAAA;EACA,iBAAA;AAHJ;;AAMA;EACI,WAAA;EACA,YAAA;EACA,+CAAA;EACA,8BAAA;EACA,iCAAA;EACA,qCAAA;EACA,qCAAA;EACA,iBAAA;AAHJ;;AAMA;EACI,WAAA;EACA,YAAA;EACA,6BAAA;EACA,8BAAA;EACA,iCAAA;EACA,qCAAA;EACA,qCAAA;EACA,iBAAA;AAHJ;;AAMA,sBAAA;AACA;EACI,+CAAA;EACA,YAAA;EACA,uCAAA;EACA,mBAAA;EACA,iBAAA;AAHJ;;AAMA;EACI,UAAA;EACA,kBAAA;AAHJ;;AAMA;EACI,YAAA;EACA,+CAAA;EACA,8BAAA;EACA,iCAAA;EACA,qCAAA;EACA,qCAAA;EACA,uCAAA;EACA,sCAAA;EACA,uCAAA;AAHJ;;AAMA;EACI,YAAA;EACA,cAAA;EACA,+CAAA;EACA,8BAAA;EACA,iCAAA;EACA,qCAAA;EACA,qCAAA;EACA,uCAAA;EACA,sCAAA;EACA,uCAAA;AAHJ;;AAMA;EACI,YAAA;EACA,cAAA;EACA,+CAAA;EACA,8BAAA;EACA,iCAAA;EACA,qCAAA;EACA,qCAAA;EACA,uCAAA;EACA,sCAAA;EACA,uCAAA;AAHJ;;AAMA;EACI,mBAAA;EACA,gBAAA;AAHJ;;AAMA;EACI,sBAAA;EACA,kBAAA;AAHJ;;AAMA;EACI,mBAAA;EACA,kBAAA;AAHJ;;AAMA;EACI,sBAAA;EACA,kBAAA;AAHJ;;AAMA;EACI,sBAAA;EACA,gBAAA;AAHJ;;AAMA;EACI,mBAAA;AAHJ;;AAMA;EACI,sBAAA;AAHJ;;AAMA;EACI,sBAAA;AAHJ;;AAMA;EACI,gBAAA;AAHJ;;AAMA;EACI,kBAAA;AAHJ;;AAMA;EACI,iBAAA;AAHJ;;AAMA;EACI,UAAA;AAHJ;;AAMA,wBAAA;AACA;EACI,gBAAA;AAHJ;;AAMA;EACI,YAAA;EACA,yDAAA;EACA,wCAAA;EACA,iCAAA;EACA,+CAAA;AAHJ;;AAMA;EACI,YAAA;EACA,6CAAA;EACA,wCAAA;EACA,4CAAA;EACA,4BAAA;EACA,iCAAA;EACA,+CAAA;EACA,qCAAA;EACA,2CAAA;EACA,kCAAA;EACA,mBAAA;EACA,iBAAA;AAHJ;;AAMA;EACI,YAAA;EACA,yDAAA;EACA,wCAAA;EACA,iCAAA;EACA,+CAAA;EACA,qCAAA;EACA,kCAAA;EACA,mBAAA;EACA,iBAAA;AAHJ;;AAMA;EACI,YAAA;EACA,yDAAA;EACA,wCAAA;EACA,iCAAA;EACA,+CAAA;EACA,qCAAA;EACA,gBAAA;EACA,mBAAA;EACA,kCAAA;EACA,mBAAA;EACA,iBAAA;AAHJ;;AAMA;EACI,YAAA;EACA,gBAAA;EACA,MAAA;EACA,yDAAA;EACA,wCAAA;EACA,iCAAA;EACA,+CAAA;EACA,qCAAA;EACA,kCAAA;EACA,iBAAA;EACA,mBAAA;AAHJ;;AAMA;EACI,UAAA;AAHJ;;AAMA;EACI,iBAAA;EACA,oBAAA;EACA,iBAAA;EACA,sBAAA;AAHJ;;AAMA;;qEAAA;AAGA;;;CAAA;AAKA;;qEAAA;AAGA;;;CAAA;AAKA;;qEAAA;AAGA;;;CAAA;AAKA;;qEAAA;AAGA;;;CAAA","sourcesContent":["/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n| EzClocker Table UX CSS Classes\r\n| CSS variables defined in: /src/main/webapp/public/styles/common/ez-body.css\r\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */\r\n\r\n:root {\r\n    /* Default Table Background */\r\n    --ezTableBackgroundColor: var(--ezClockerWhite);\r\n\r\n    /* Default Table Font */\r\n    --ezTableFontColor: var(--ezFontColor);\r\n    --ezTableFontSize: 12pt;\r\n    --ezTableFontWeight: var(--ezFontWeight);\r\n    --ezTableFontFamily: var(--ezTextFontFamily);\r\n\r\n    /* Default Table Border */\r\n    --ezTableBorderColor: var(--ezClockerGray);\r\n    --ezTableBorderSize: 1px;\r\n    --ezTableBorderStyle: solid;\r\n\r\n    /* Header Cells */\r\n    --ezTableHeaderCellBackgroundColor: var(--ezClockerNavy);\r\n    --ezTableHeaderCellFontColor: var(--ezClockerWhite);\r\n    --ezTableHeaderCellFontWeight: bold;\r\n}\r\n\r\n/* Table Styles */\r\ntable.ez-table {\r\n    background-color: var(--ezTableBackgroundColor);\r\n    color: var(--ezTableFontColor);\r\n    font-size: var(--ezTableFontSize);\r\n    font-weight: var(--ezTableFontWeight);\r\n    font-family: var(--ezTableFontFamily);\r\n    border-spacing: 0;\r\n}\r\n\r\ntable.ez-table-transparent-full-width {\r\n    width: 100%;\r\n    padding: 2px;\r\n    background-color: transparent;\r\n    color: var(--ezTableFontColor);\r\n    font-size: var(--ezTableFontSize);\r\n    font-weight: var(--ezTableFontWeight);\r\n    font-family: var(--ezTableFontFamily);\r\n    border-spacing: 0;\r\n}\r\n\r\ntable.ez-table-full-width {\r\n    width: 100%;\r\n    padding: 2px;\r\n    background-color: var(--ezTableBackgroundColor);\r\n    color: var(--ezTableFontColor);\r\n    font-size: var(--ezTableFontSize);\r\n    font-weight: var(--ezTableFontWeight);\r\n    font-family: var(--ezTableFontFamily);\r\n    border-spacing: 0;\r\n}\r\n\r\ntable.ez-table-full-width-transparent {\r\n    width: 100%;\r\n    padding: 2px;\r\n    background-color: transparent;\r\n    color: var(--ezTableFontColor);\r\n    font-size: var(--ezTableFontSize);\r\n    font-weight: var(--ezTableFontWeight);\r\n    font-family: var(--ezTableFontFamily);\r\n    border-spacing: 0;\r\n}\r\n\r\n/* Table Body Styles */\r\ntbody.ez-table-body {\r\n    background-color: var(--ezTableBackgroundColor);\r\n    padding: 2px;\r\n    border-color: var(--ezTableBorderColor);\r\n    border-style: solid;\r\n    border-width: 1px;\r\n}\r\n\r\ntr.ez-table-row {\r\n    padding: 0;\r\n    border-style: none;\r\n}\r\n\r\ntd.ez-table-cell {\r\n    padding: 4px;\r\n    background-color: var(--ezTableBackgroundColor);\r\n    color: var(--ezTableFontColor);\r\n    font-size: var(--ezTableFontSize);\r\n    font-weight: var(--ezTableFontWeight);\r\n    font-family: var(--ezTableFontFamily);\r\n    border-color: var(--ezTableBorderColor);\r\n    border-width: var(--ezTableBorderSize);\r\n    border-style: var(--ezTableBorderStyle);\r\n}\r\n\r\ntd.ez-table-cell-max-width-50 {\r\n    padding: 4px;\r\n    max-width: 50%;\r\n    background-color: var(--ezTableBackgroundColor);\r\n    color: var(--ezTableFontColor);\r\n    font-size: var(--ezTableFontSize);\r\n    font-weight: var(--ezTableFontWeight);\r\n    font-family: var(--ezTableFontFamily);\r\n    border-color: var(--ezTableBorderColor);\r\n    border-width: var(--ezTableBorderSize);\r\n    border-style: var(--ezTableBorderStyle);\r\n}\r\n\r\ntd.ez-table-cell-min-width-50 {\r\n    padding: 4px;\r\n    min-width: 50%;\r\n    background-color: var(--ezTableBackgroundColor);\r\n    color: var(--ezTableFontColor);\r\n    font-size: var(--ezTableFontSize);\r\n    font-weight: var(--ezTableFontWeight);\r\n    font-family: var(--ezTableFontFamily);\r\n    border-color: var(--ezTableBorderColor);\r\n    border-width: var(--ezTableBorderSize);\r\n    border-style: var(--ezTableBorderStyle);\r\n}\r\n\r\n.ez-cell-align-top-left {\r\n    vertical-align: top;\r\n    text-align: left;\r\n}\r\n\r\n.ez-cell-align-middle-center {\r\n    vertical-align: middle;\r\n    text-align: center;\r\n}\r\n\r\n.ezTable-cell-align-top-center {\r\n    vertical-align: top;\r\n    text-align: center;\r\n}\r\n\r\n.ezTable-cell-align-bottom-center {\r\n    vertical-align: bottom;\r\n    text-align: center;\r\n}\r\n\r\n.ez-cell-align-middle-left {\r\n    vertical-align: middle;\r\n    text-align: left;\r\n}\r\n\r\n.ez-cell-vertical-align-top {\r\n    vertical-align: top;\r\n}\r\n\r\n.ez-cell-vertical-align-bottom {\r\n    vertical-align: bottom;\r\n}\r\n\r\n.ez-cell-vertical-align-middle {\r\n    vertical-align: middle;\r\n}\r\n\r\n.ez-cell-horizontal-align-left {\r\n    text-align: left;\r\n}\r\n\r\n.ez-cell-horizontal-align-center {\r\n    text-align: center;\r\n}\r\n\r\n.ez-cell-horizontal-align-right {\r\n    text-align: right;\r\n}\r\n\r\ntd.ez-cell-width-33 {\r\n    width: 33%;\r\n}\r\n\r\n/* Table Header Styles */\r\nthead.ez-sticky-table-header {\r\n    position: sticky;\r\n}\r\n\r\nthead.ez-table-header {\r\n    padding: 4px;\r\n    background-color: var(--ezTableHeaderCellBackgroundColor);\r\n    color: var(--ezTableHeaderCellFontColor);\r\n    font-size: var(--ezTableFontSize);\r\n    font-weight: var(--ezTableHeaderCellFontWeight);\r\n}\r\n\r\nth.ezTables-cell-header-silver {\r\n    padding: 4px;\r\n    /* --ezClockerSilver defined in ez-body.css */\r\n    background-color: var(--ezClockerSilver);\r\n    /* --ezClockerBlack defined in ez-body.css */\r\n    color: var(--ezClockerBlack);\r\n    font-size: var(--ezTableFontSize);\r\n    font-weight: var(--ezTableHeaderCellFontWeight);\r\n    font-family: var(--ezTableFontFamily);\r\n    /* --ezClockerGray defined in ez-body.css */\r\n    border-color: var(--ezClockerGray);\r\n    border-style: solid;\r\n    border-width: 1px;\r\n}\r\n\r\nth.ez-table-cell-header {\r\n    padding: 4px;\r\n    background-color: var(--ezTableHeaderCellBackgroundColor);\r\n    color: var(--ezTableHeaderCellFontColor);\r\n    font-size: var(--ezTableFontSize);\r\n    font-weight: var(--ezTableHeaderCellFontWeight);\r\n    font-family: var(--ezTableFontFamily);\r\n    border-color: var(--ezClockerGray);\r\n    border-style: solid;\r\n    border-width: 1px;\r\n}\r\n\r\nth.ez-table-cell-header-left-align {\r\n    padding: 4px;\r\n    background-color: var(--ezTableHeaderCellBackgroundColor);\r\n    color: var(--ezTableHeaderCellFontColor);\r\n    font-size: var(--ezTableFontSize);\r\n    font-weight: var(--ezTableHeaderCellFontWeight);\r\n    font-family: var(--ezTableFontFamily);\r\n    text-align: left;\r\n    vertical-align: top;\r\n    border-color: var(--ezClockerGray);\r\n    border-style: solid;\r\n    border-width: 1px;\r\n}\r\n\r\nth.ez-table-cell-header-fixed {\r\n    padding: 4px;\r\n    position: sticky;\r\n    top: 0;\r\n    background-color: var(--ezTableHeaderCellBackgroundColor);\r\n    color: var(--ezTableHeaderCellFontColor);\r\n    font-size: var(--ezTableFontSize);\r\n    font-weight: var(--ezTableHeaderCellFontWeight);\r\n    font-family: var(--ezTableFontFamily);\r\n    border-color: var(--ezClockerGray);\r\n    border-width: 1px;\r\n    border-style: solid;\r\n}\r\n\r\ntd.ez-table-cell-width-50 {\r\n    width: 50%;\r\n}\r\n\r\ntd.ezTable-action-buttons-col {\r\n    padding-top: 10px;\r\n    padding-bottom: 10px;\r\n    text-align: right;\r\n    vertical-align: middle;\r\n}\r\n\r\n/* -------------------------------------------------------------------\r\n| Large Tablet Screen Styles (https://yesviz.com/laptops.php)       |\r\n------------------------------------------------------------------- */\r\n/*\r\n@media screen and (max-width: 1023px) {\r\n}\r\n*/\r\n\r\n/* -------------------------------------------------------------------\r\n| Small Tablet Screen Styles (https://yesviz.com/tablets.php)       |\r\n------------------------------------------------------------------- */\r\n/*\r\n@media screen and (max-width: 768px) {\r\n}\r\n*/\r\n\r\n/* -------------------------------------------------------------------\r\n| Phone Screen Styles  (https://yesviz.com/mobiles.php)             |\r\n------------------------------------------------------------------- */\r\n/*\r\n@media screen and (max-width: 480px) {\r\n}\r\n*/\r\n\r\n/* -------------------------------------------------------------------\r\n| Warable Screen Style  (https://yesviz.com/watches.php)            |\r\n------------------------------------------------------------------- */\r\n/*\r\n@media screen and (max-width: 319px) {\r\n}\r\n*/"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
